import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { RouteMap } from '@common/constants/RouteMap';

const MyDebts = lazy(() => import('../pages/MyDebts'));

export function Router() {
  return <Route path={RouteMap.MyDebts} element={<MyDebts />} />;
}
